import React from 'react';
import { NOTE_COLORS } from './types';

const NoteComponent = ({ content, color, onUpdate }) => {
  const handleContentChange = (e) => {
    onUpdate({ content: e.target.value });
  };

  const handleColorChange = (newColor) => {
    onUpdate({ color: newColor });
  };

  return (
    <div className="wb-note" style={{ backgroundColor: color }}>
      {/* Color picker dots */}
      <div className="wb-note-colors">
        {NOTE_COLORS.map((c) => (
          <button
            key={c}
            className={`wb-note-color-dot ${color === c ? 'active' : ''}`}
            style={{ backgroundColor: c }}
            onClick={(e) => {
              e.stopPropagation();
              handleColorChange(c);
            }}
            title="Change color"
          />
        ))}
      </div>

      {/* Note content */}
      <textarea
        className="wb-note-textarea"
        value={content}
        onChange={handleContentChange}
        placeholder="Type a note..."
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
};

export default React.memo(NoteComponent);
